/**
 * Simple AB test to show different copy to different organizations
 * @param organizationId - the organization id
 * @returns "A" or "B" which is which copy to show
 */
export function copyToShow(organizationId: string): "A" | "B" {
  const lastChar = organizationId.slice(-1)

  // Check if the last character is one of the first 8 characters of the hex alphabet
  const firstHalfOfHexChars = "01234567"
  if (firstHalfOfHexChars.includes(lastChar.toLowerCase())) {
    return "A"
  } else {
    return "B"
  }
}
